var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-widget__info order-widget__info--slots" },
    [
      _c("span", { staticClass: "order-widget__days" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.duration) +
            " " +
            _vm._s(_vm.i18n.t("general:non_special_texts.days")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "order-widget__slots" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.slots) +
            " " +
            _vm._s(
              _vm.i18n.t(_vm.cloudUnitType.loco_key, { count: _vm.slots })
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order-widget__price" },
        [
          _c(
            "span",
            {
              staticClass: "order-widget__price-label",
              class: {
                "order-widget__price-label--has-extras": _vm.extras.length > 0,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.formattedPrice) + "\n    ")]
          ),
          _vm._v(" "),
          _vm._l(_vm.extras, function (extra, index) {
            return _c("span", {
              key: extra.key,
              staticClass: "order-widget__price-extra",
              class: { "order-widget__price-extra--first": index === 0 },
              domProps: {
                innerHTML: _vm._s(
                  _vm.i18n.t(extra.loco_key, {
                    units: extra.units,
                    unitType: _vm.i18n.t("general:non_special_texts.gigabyte"),
                  })
                ),
              },
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }